module.exports = __webpack_public_path__ + "static/media/resort-carousel-bg.b4332223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resort-carousel-bg.jpg
// module id = 1252
// module chunks = 0